module.exports = __webpack_public_path__ + "8cb9592e3fe71aeef41f60ef37540472.jpg";